import loadable from '@loadable/component';

export const WhathifiSiteWrapper = loadable(
  () => import(/* webpackChunkName: "whathifi-site" */ './WhathifiSiteWrapper'),
);
